import { render, staticRenderFns } from "./TitulosEmRevisao.vue?vue&type=template&id=5c72bd70"
import script from "./TitulosEmRevisao.vue?vue&type=script&lang=js"
export * from "./TitulosEmRevisao.vue?vue&type=script&lang=js"
import style0 from "./TitulosEmRevisao.vue?vue&type=style&index=0&id=5c72bd70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports